<template>
  <div class="h-full">
    <div class="h-full flex flex-col" style="width:100%">
      <!-- <div class="Polaris-FullscreenBar"> -->
      <!-- <button
          class="Polaris-FullscreenBar__BackAction"
          aria-label="Exit fullscreen mode"
          @click="exitFullScreen"
        >
          <span class="Polaris-Icon">
            <span class="Polaris-Text--root Polaris-Text--visuallyHidden">
            </span>
            <svg
              viewBox="0 0 20 20"
              class="Polaris-Icon__Svg"
              focusable="false"
              aria-hidden="true"
            >
              <path
                d="M7.703 13.707a.997.997 0 0 0 0-1.414l-1.294-1.293h6.589a1 1 0 1 0 0-2h-6.589l1.294-1.293a1 1 0 1 0-1.415-1.414l-3.001 3a.994.994 0 0 0-.198.298c-.013.027-.021.054-.03.082a.944.944 0 0 0-.054.269l-.001.027a.937.937 0 0 0 .062.398l.003.012v.004c.048.112.117.208.197.294l.01.015.01.015 3.002 3a1 1 0 0 0 1.415 0z"
              ></path>
              <path
                d="M2 16.5a1.5 1.5 0 0 0 1.5 1.5h13a1.5 1.5 0 0 0 1.5-1.5v-13a1.5 1.5 0 0 0-1.5-1.5h-13a1.5 1.5 0 0 0-1.5 1.5v1.5a1 1 0 1 0 2 0v-1h12v12h-12v-1a1 1 0 1 0-2 0v1.5z"
              ></path>
            </svg> </span
          >Back
        </button> -->
      <!-- <div
          style="display:flex;flex-grow:1;justify-content:space-between;align-items:center;padding-left:1rem;padding-right:1rem"
        >
          <div style="margin-left:1rem;flex-grow:1">
            <p class="Polaris-Text--root Polaris-Text--headingLg">Team Inbox</p>
          </div>
        </div> -->
      <!-- </div> -->
      <NotificationBanner></NotificationBanner>
      <div class="flex-1 flex overflow-hidden">
        <div class="flex-1 flex overflow-hidden">
          <div class="flex-1 flex overflow-hidden">
            <main class="flex-1 flex bg-gray-200" v-if="hasLoaded">
              <InboxSidebar />
              <router-view />
            </main>
            <span v-else>
              Loading team inbox....
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAuth, signInWithCustomToken } from "firebase/auth";

import InboxSidebar from "../../components/TeamInbox/InboxSidebar";
import NotificationBanner from "../../components/TeamInbox/NotificationBanner";

import { Fullscreen } from "@shopify/app-bridge/actions";

import Inbox from "../../store/Inbox/index";

export default {
  name: "TeamInbox",
  components: {
    InboxSidebar,
    NotificationBanner
  },
  data() {
    return {
      hasLoaded: false
    };
  },
  created() {
    // if (window.appBridgeApp) {
    //   const fullscreen = Fullscreen.create(window.appBridgeApp);
    //   fullscreen.dispatch(Fullscreen.Action.ENTER);
    // }

    this.$store.registerModule("Inbox", Inbox);
    this.$store
      .dispatch("Inbox/getToken")
      .then(response => {
        console.log(response);
        return this.login(response.token);
      })
      .then(() => {
        this.hasLoaded = true;
        this.$store.dispatch("Inbox/getHome");
        this.$store.dispatch("Inbox/getSavedReplies");
        this.$store.dispatch("Inbox/getTags");
        this.$store.dispatch("Inbox/getTemplateMessage");
        this.setEmailOnCrisp();
      });
  },
  beforeDestroy() {
    this.$store.unregisterModule("Inbox");
  },
  methods: {
    login(token) {
      const auth = getAuth();
      return signInWithCustomToken(auth, token);
    },
    async setEmailOnCrisp() {
      const response = await this.$store.dispatch("getUser");
      await this.$store.dispatch("getConfig");
      // eslint-disable-next-line
      if (response && response.user && response.user.email && $crisp) {
        // eslint-disable-next-line
        $crisp.push(["set", "user:email", [response.user.email]]);
        const store = this.$store.getters.getStore;
        const shopifyPlan = this.$store.getters.getShopifyPlan;
        // eslint-disable-next-line
        $crisp.push([
          "set",
          "session:data",
          [
            [
              ["plan", store.plan],
              ["hasReviewed", store.hasReviewed],
              ["manualMessageSent", store.manualMessageSent],
              ["shopOrigin", store.shopOrigin],
              [
                "sendMessagesUsingDesktopApp",
                store.sendMessagesUsingDesktopApp
              ],
              ["storeId", store.id],
              ["shopifyPlan", shopifyPlan]
            ]
          ]
        ]);
      }
    },
    joinWaitlist() {
      window.open(
        "https://web.whatsapp.com/send/?phone=+916374746603&text=I need team inbox",
        "_new"
      );
      this.$store
        .dispatch("joinWaitList", {
          requestParams: { feature: "teamInbox" }
        })
        .then(() => {
          this.isSaving = false;
          this.$store.dispatch("getConfig");
        });
    },
    exitFullScreen() {
      const fullscreen = Fullscreen.create(window.appBridgeApp);
      fullscreen.dispatch(Fullscreen.Action.EXIT);
      this.$router.go(-2);
    }
  }
};
</script>

<style lang="scss" scoped></style>
